
define('text!modules/version/templates/info.html',[],function () { return '<div class="version-info">\n    <div class="version-number label" data-bind="current_version">\n      {{current_version}}\n    </div>\n</div>';});

